import { mergeTemplate } from './base-template';

export const schweizerKmuTemplate = mergeTemplate({
  name: 'Schweizer KMU Landing',
  icon: '🇨🇭',
  settings: {
    fontStack: 'instrument',
    darkModeToggle: true,
    stylePreset: 'gasserwerk',
    designDensity: 'airy',
    pageAngebot: {
      heroTitle: 'Unsere Leistungspakete',
      heroSubtitle: 'Klare Angebote für Ihr KMU — transparent und fair',
      packages: [
        { name: 'Starter', price: 'ab CHF 490/Mt.', description: 'Ideal für Einzelfirmen und Startups', features: 'Buchhaltung, Lohnabrechnung, Mahnwesen, Quartals-Reporting', highlighted: false },
        { name: 'Growth', price: 'ab CHF 890/Mt.', description: 'Für wachsende KMU mit mehreren Mitarbeitenden', features: 'Starter + Steuerplanung, Budgetierung, Personaladmin, Monats-Reporting', highlighted: true },
        { name: 'Enterprise', price: "ab CHF 1'490/Mt.", description: 'Full-Service für etablierte Unternehmen', features: 'Growth + Revision, Strategieberatung, Nachfolgeplanung, CFO-on-Demand', highlighted: false },
      ],
      ctaTitle: 'Das passende Paket für Ihr KMU',
      ctaText: 'Wir beraten Sie gerne persönlich und finden die richtige Lösung für Ihre Situation.',
      ctaButtonText: 'Kostenloses Beratungsgespräch',
    },
    pageMethoden: {
      heroTitle: 'Unsere Arbeitsweise',
      heroSubtitle: 'Strukturiert, digital und persönlich',
      introText: 'Wir verbinden bewährte Methoden mit modernen Tools — damit Sie sich auf Ihr Kerngeschäft konzentrieren können.',
      steps: [
        { title: 'Analyse', description: 'Wir erfassen Ihre aktuelle Situation, Prozesse und Bedürfnisse' },
        { title: 'Strategie', description: 'Gemeinsam definieren wir Ziele, Umfang und Arbeitsweise' },
        { title: 'Umsetzung', description: 'Wir übernehmen die laufenden Aufgaben — zuverlässig und termingerecht' },
        { title: 'Optimierung', description: 'Regelmässige Reviews und Anpassungen für noch bessere Ergebnisse' },
      ],
      tools: [
        { name: 'Bexio', description: 'Cloud-Buchhaltung für Schweizer KMU' },
        { name: 'KLARA', description: 'Lohnbuchhaltung und Sozialversicherungen' },
        { name: 'Microsoft 365', description: 'Zusammenarbeit und Dokumentenmanagement' },
      ],
      philosophyTitle: 'Unsere Philosophie',
      philosophyText: 'Pragmatisch, transparent und immer auf Augenhöhe. Wir sind Ihr verlängertes Backoffice — nicht nur ein Dienstleister.',
    },
    pageUeberMich: {
      heroTitle: 'Über uns',
      heroSubtitle: 'Ihr Partner für Buchhaltung, Organisation und mehr',
      introText: 'Als inhabergeführtes Unternehmen kennen wir die Herausforderungen von Schweizer KMU aus erster Hand.',
      imageUrl: '',
      timeline: [
        { year: '2015', text: 'Gründung als Einzelfirma' },
        { year: '2019', text: 'Umstellung auf digitale Prozesse' },
        { year: '2023', text: 'Wachstum auf 5 Mitarbeitende' },
      ],
      values: [
        { title: 'Verlässlichkeit', description: 'Termine und Zusagen halten wir ein — ohne Ausnahme' },
        { title: 'Transparenz', description: 'Klare Kommunikation, faire Preise, keine versteckten Kosten' },
        { title: 'Pragmatismus', description: 'Lösungen, die zu Ihrem KMU passen — nicht umgekehrt' },
      ],
      certifications: 'Schweizer Treuhand-Kammer, Bexio-zertifiziert',
    },
  },
  components: {
    header: {
      companyName: 'Musterfirma GmbH',
      logoText: 'MF',
      navItems: ['Leistungen', 'Methoden', 'Team', 'Kontakt'],
      ctaText: 'Kostenlos beraten lassen',
    },
    hero: {
      title: 'Mehr Zeit fürs Kerngeschäft. Weniger Admin.',
      subtitle:
        'Buchhaltung, Organisation und Backoffice – klar, effizient und zuverlässig.',
      primaryBtn: 'Kostenloses Erstgespräch',
      secondaryBtn: 'Leistungen ansehen',
      imageUrl: '',
    },
    trust: {
      items: [
        { value: 'Schweiz', label: 'Lokale Nähe' },
        { value: 'Transparent', label: 'Klare Offerten' },
        { value: 'Digital', label: 'Moderne Prozesse' },
        { value: 'Persönlich', label: 'Fixer Kontakt' },
      ],
    },
    services: {
      title: 'Unsere Leistungen',
      subtitle: 'Pragmatisch, terminsicher, passend zu Ihrem KMU.',
      items: [
        {
          icon: '📊',
          title: 'Finanzbuchhaltung',
          text: 'Saubere Fibu, Abstimmungen, Auswertungen – digital und nachvollziehbar.',
        },
        {
          icon: '💳',
          title: 'Debitoren/Kreditoren',
          text: 'Rechnungen, Mahnwesen, Zahlungsabgleich – mit klaren Prozessen.',
        },
        {
          icon: '🧾',
          title: 'Jahresabschluss',
          text: 'Abschluss nach OR, Vorbereitung für Steuern und Banken, sauber dokumentiert.',
        },
      ],
    },
    benefits: {
      title: 'Warum mit uns?',
      subtitle: 'Kompetenz, Klarheit und Verlässlichkeit.',
      items: [
        {
          title: 'Planbarkeit',
          text: 'Klare Pakete oder transparente Abrechnung – ohne Überraschungen.',
        },
        {
          title: 'Proaktive Kommunikation',
          text: 'Fristen, To-dos und offene Punkte werden frühzeitig adressiert.',
        },
        {
          title: 'Digitale Zusammenarbeit',
          text: 'Dokumente, Belege und Abstimmungen so effizient wie möglich.',
        },
      ],
    },
    team: {
      title: 'Unser Team',
      subtitle: 'Persönliche Ansprechpartner für Ihr KMU.',
      members: [
        {
          name: 'Thomas Gerber',
          role: 'Geschäftsführer & Berater',
          image: '',
          bio: 'Gründer der Musterfirma GmbH mit über 12 Jahren Erfahrung in der KMU-Beratung und Buchhaltung.',
        },
        {
          name: 'Andrea Wyss',
          role: 'Buchhaltung & Administration',
          image: '',
          bio: 'Verantwortlich für die laufende Finanzbuchhaltung und das Debitoren-Management unserer Mandanten.',
        },
      ],
    },
    testimonials: {
      title: 'Was Kunden schätzen',
      items: [
        {
          quote:
            'Endlich haben wir saubere Zahlen und Ruhe bei Fristen.',
          author: 'K. Müller',
          role: 'Geschäftsführer, KMU',
        },
        {
          quote:
            'Die Zusammenarbeit ist digital – aber trotzdem persönlich.',
          author: 'S. Meier',
          role: 'Inhaberin',
        },
        {
          quote:
            'Seit wir mit der Musterfirma arbeiten, haben wir endlich Überblick über unsere Finanzen. Sehr empfehlenswert.',
          author: 'B. Frei',
          role: 'Inhaber, Schreinerei',
        },
        {
          quote:
            'Kompetent, erreichbar und fair im Preis. Genau das, was ein kleines KMU braucht.',
          author: 'L. Weber',
          role: 'Geschäftsleiterin, Handelsunternehmen',
        },
      ],
    },
    faq: {
      title: 'Häufige Fragen',
      subtitle: 'Kurz beantwortet – gerne auch persönlich.',
      items: [
        {
          question: 'Wie läuft das Onboarding ab?',
          answer:
            'Wir starten mit einem Erstgespräch, definieren den Umfang und richten die Zusammenarbeit (Tools, Ablage, Prozesse) ein.',
        },
        {
          question: 'Gibt es Fixpreise?',
          answer:
            'Ja – je nach Umfang bieten wir Pakete oder eine transparente Abrechnung nach Aufwand.',
        },
        {
          question: 'Arbeitet ihr digital?',
          answer:
            'Ja. Wir unterstützen cloudbasierte Abläufe und pragmatische digitale Prozesse.',
        },
        {
          question: 'Für welche Branchen arbeitet ihr?',
          answer:
            'Wir betreuen KMU aus verschiedensten Branchen — vom Handwerksbetrieb über Gastro bis zu Dienstleistungsunternehmen. Unsere Prozesse passen wir an Ihre Branche an.',
        },
      ],
    },
    cta: {
      title: 'Bereit für weniger Admin?',
      subtitle:
        'Vereinbaren Sie ein kostenloses Erstgespräch. Wir melden uns zeitnah.',
      phone: '+41 00 000 00 00',
      email: 'info@example.ch',
    },
    stickyCta: {
      text: 'Fragen zu Buchhaltung oder Steuern?',
      buttonText: 'Rückruf anfordern',
      phone: '+41 00 000 00 00',
      note: 'Diskret & unverbindlich',
    },
    footer: {
      companyName: 'Musterfirma GmbH',
      tagline: 'Zuverlässige Services für Schweizer KMU.',
      address: 'Musterstrasse 1, 8000 Zürich',
      phone: '+41 00 000 00 00',
      email: 'info@example.ch',
    },
  },
});
